import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-icon',
  imports: [NgOptimizedImage],
  templateUrl: './app-icon.html',
  styleUrl: './app-icon.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppIcon {
  readonly icon = input.required<string>();
  readonly color = input<string | null>(null);
  readonly forceMask = input(false);
  readonly width = input(18);
  readonly height = input(18);
  readonly alt = input('');

  protected readonly isFontAwesomeIcon = computed(() => {
    const iconClasses = this.icon().trim().split(/\s+/);

    return iconClasses.some((iconClass) => iconClass === 'fa' || iconClass.startsWith('fa-') || /^fa[brsldtk]$/.test(iconClass));
  });

  protected readonly iconSource = computed(() => {
    const icon = this.icon();

    if (this.isFontAwesomeIcon() || icon.includes('/') || icon.includes('\\')) {
      return icon;
    }

    return `/assets/icons/${icon}`;
  });

  protected readonly isSvgIcon = computed(() => {
    const iconUrl = this.iconSource().split(/[?#]/, 1)[0].toLowerCase();

    return iconUrl.endsWith('.svg');
  });

  protected readonly preservesSvgColors = computed(() => {
    const iconUrl = this.iconSource().split(/[?#]/, 1)[0].toLowerCase().replaceAll('\\', '/');

    return iconUrl.endsWith('/icon-shield-solid.svg')
      || iconUrl === 'icon-shield-solid.svg'
      || iconUrl.endsWith('/icon-text-b1.svg')
      || iconUrl === 'icon-text-b1.svg';
  });

  protected readonly usesMask = computed(() => this.isSvgIcon() && !this.preservesSvgColors() && (!!this.color() || this.forceMask()));
}
